<template lang="html">
    <div id="cultivate_train"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="titleName"
                :subTitle="subTitle"
                :btnAgree="agreedOnOff"
                :btnRefuse="refusedOnOff"
                :btnSubmit="submitOnOff"
                :btnSave="saveOnOff"
                :btnBack="true"
                :btnDelete="deleteOnOff"
                @btnDeleteClick="btnDeleteClick"
                @btnAgreeClick="btnAgreeClick" @btnRefuseClick="btnRefuseClick" @btnSubmitClick="btnSubmitClick" @btnSaveClick="inputBtnSaveClick"  @btnBackClick="handleBackClick"/>
        <div v-if="status === 'INFO'" style="width: 70%;margin-top:10px;float: left;">
            <el-form :disabled="onOff"
                     label-width="90px" :model="form" ref="infoForm">
                <el-row>
                    <el-col>
                        <el-form-item label="日期" :rules="[{required:true,message:'日期不能为空'}]" prop="activity_date">
                            <el-date-picker
                                    v-model="form.activity_date"
                                    type="date"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 98%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="时长" :rules="[{required:true,message:'时长不能为空'}]" prop="activity_duration">
                            <el-select
                                    style="width: 98%"
                                    v-model="form.activity_duration"
                                    placeholder="选择时长" clearable>
                                <el-option
                                        v-for="item in activity_duration"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="类型" :rules="[{required:true,message:'类型不能为空'}]" prop="affair_type">
                            <el-select
                                    style="width: 98%"
                                    v-model="form.affair_type"
                                    @change="onTypeChange"
                                    placeholder="选择类型" clearable>
                                <el-option
                                        v-for="item in options_duration"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="说明">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="form.comments"
                                    style="width: 98%;">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div v-else style="width: 70%;margin-top:10px;float: left;">
            <el-form label-width="90px" :model="addForm" ref="addForm">
                <el-row>
                    <el-col>
                        <el-form-item label="日期" :rules="[{required:true,message:'日期不能为空'}]" prop="activity_date">
                            <el-date-picker
                                    v-model="addForm.activity_date"
                                    type="date"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 98%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="时长" :rules="[{required:true,message:'时长不能为空'}]" prop="activity_duration">
                            <el-select
                                    style="width: 98%"
                                    v-model="addForm.activity_duration"
                                    placeholder="选择时长" clearable>
                                <el-option
                                        v-for="item in activity_duration"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="类型" :rules="[{required:true,message:'类型不能为空'}]" prop="affair_type">
                            <el-select
                                    style="width: 98%"
                                    v-model="addForm.affair_type"
                                    @change="onTypeChange"
                                    value-key="key"
                                    placeholder="选择类型" clearable>
                                <el-option
                                        v-for="item in options_duration"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="说明">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="addForm.comments"
                                    style="width: 98%;">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!--        右侧留言-->
        <div v-if="status === 'INFO'"
             style="width: 27%;float: left;border:1px solid #DEDEDE;background: #F4F6F8;margin-top:10px;margin-left:2.8%;
             border-radius: 8px;min-height: calc(100% - 115px);box-sizing: border-box;">
            <el-row>
                <el-button @click="openSavePlanModel"
                           :class="['iconfont', 'el-icon-edit-outline',]" size="small"
                           type="primary"
                           style="float:right;height:32px;padding: 8px 10px;
                           margin-top: 10px;margin-right: 10px;">
                    <i></i>写一笔</el-button>
            </el-row>

            <el-row style="overflow: auto">
                <el-col v-for="(item,j) in form.psArray" style="padding: 5%;">
                    <div style="width: 30px;height: 30px;float: left;overflow: hidden;border-radius: 100%;
                            position: relative">
                        <img v-if="item.src" :src="item.src"
                             width="100%"
                             alt="" style=" position: absolute;
                                        top:50%;
                                        left:50%;
                                        transform: translate(-50%,-50%);">
                    </div>
                    <div style="float:right;width: calc(100% - 50px)">
                        <p style="margin-top:0%;margin-bottom:0%;color: #4D586D;font-size: 12px">{{item.last_name}}</p>
                        <p :class="['iconfont','el-icon-time',]"
                           style="color: #87909A;margin-top:5px;margin-bottom:0%;font-size: 12px;"><i></i>{{
                            item.timestamp | componentFliter}}</p>
                        <p style="white-space:normal;
                        margin-top:10px;margin-bottom:5%;
                        word-break:break-all;overflow:hidden;
                        width:90%;color: #4A4A4A;font-size: 13px;line-height: 20px">{{item.contents.comments}}</p>
                    </div>
                </el-col>

            </el-row>
        </div>
        <el-dialog
                id="travelSavePlanPs"
                :visible.sync="modelSavePlanPs"
                :before-close="handleClose"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">写一笔
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="savePlanPs()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="modelSavePlanPs = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px">
                <el-input type="textarea" v-model="contents"> </el-input>

            </div>
        </el-dialog>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import tou from '../../../assets/images/tou.png'
    import moment from 'moment'
    export default {
        name: "medical",
        data() {
            return {
                id: "",
                loading: false,
                tags: ['日程安排','公司会议/培训 '],
                titleName: this.$store.getters.getUser.alias,
                title:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:'管理员',
                subTitle: '',
                data:{},
                status:'',
                datePlan:'',
                form:{
                    reason:'',
                    expense:'',
                    start_time:'',
                    end_time:'',
                    transportation:'',
                    province_name:'',
                    city_name:''
                },
                activity_duration:[
                    {
                        label:'全天',
                        value:'FULLDAY'
                    },
                    {
                        label:'上午',
                        value:'FORENOON'
                    },
                    {
                        label:'下午',
                        value:'AFTERNOON'
                    },
                ],
                modelSavePlanPs:false,
                options_duration:[

                ],
                options_city:[],
                province_name:'',
                city_name:'',
                addForm:{
                    activity_date:'',
                    activity_duration:'',
                    comments:'',
                    start_time:'',
                    end_time:'',
                    transportation:'',
                    province_name:'',
                    city_name:'',
                },
                contents:'',
                managerOnOff:false,
                staffOnOff:false,
                staffOnOffSub:false,
                staffOnOffSave:false,
                typeDate:{},
                deleteOnOff:false,
                onOff:false,
                managerOnOff1:false,
                agreedOnOff:false,
                refusedOnOff:false,
                submitOnOff:false,
                saveOnOff:false,
                writeOnOff:true,
            }
        },
        components: {
            navBar,
            // Upload
        },

        filters:{
            componentFliter:function (value) {

                return moment(value).format('YYYY-M-D HH:mm:ss')
            }
        },
        mounted() {
            if(this.$store.getters.getUser.role === "staff") {
                this.managerOnOff1 = false
            }else {
                this.managerOnOff1 = true
            }
            if (this.managerOnOff1 === true) {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.saveOnOff=false
                this.deleteOnOff = false
            }else {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.saveOnOff=false
            }
            // document.getElementById('main').scrollTo(0, 0);
            this.getInternalType()
            if(this.$route.params.type === 'new'){
                this.status = 'NEW'
                this.data = {}
                this.datePlan = ''
                this.subTitle = '创建公司会议/培训'
                if (this.managerOnOff1 === true){
                    this.agreedOnOff=false
                    this.refusedOnOff=false
                    this.saveOnOff=true
                    this.submitOnOff=true
                } else {
                    this.submitOnOff=true
                    this.saveOnOff=true
                }
            } else if (Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.status = 'INFO'
                this.data =JSON.parse(condition)
                this.datePlan = this.data.start_time + '-' + this.data.end_time
                this.subTitle = ''
                this.titleName = this.data.titleName
                this.init()
            }else {
                this.status = 'INFO'
                this.data = this.$route.params
                this.datePlan = this.data.start_time + '-' + this.data.end_time
                this.subTitle = ''
                this.titleName = this.data.titleName
                this.init()
            }
            // console.log(this.data)
        },
        methods: {
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        activity_id : this.data.activity_id
                    }
                    await http.post('/wapi/InternalList/getInternalInfo',data).then(res=>{
                        if (res.success === true){
                            this.form = res.data

                            this.subTitle =moment(res.data.activity_date).format('YYYY年M月D日')


                            if (this.managerOnOff1 === true){
                                if (this.form.created_by !== this.$store.getters.getUser.user_id) {
                                    this.deleteOnOff = false
                                    this.onOff = true
                                    this.saveOnOff = false
                                    if (this.form.status === 'APPROVED' || this.form.status === 'DENIED' ) {
                                        this.agreedOnOff=false
                                        this.refusedOnOff=false
                                        this.onOff = true
                                    }else {
                                        this.agreedOnOff=true
                                        this.refusedOnOff=true
                                        this.onOff = true
                                    }

                                }else {
                                    this.agreedOnOff=false
                                    this.refusedOnOff=false
                                    if (this.form.status === 'SUBMITTED' || this.form.status === 'APPROVED'){
                                        this.submitOnOff = false
                                        this.onOff = false
                                        this.saveOnOff=true
                                        this.deleteOnOff = true
                                    }else {
                                        this.submitOnOff = true
                                        this.onOff = false
                                        this.saveOnOff = true
                                        this.deleteOnOff = true
                                    }
                                }
                            }else {
                                this.deleteOnOff = true
                                this.onOff = false
                                this.saveOnOff = true
                                if (this.form.status === 'SUBMITTED' || this.form.status === 'APPROVED') {
                                    this.deleteOnOff = false
                                    this.submitOnOff=false
                                    this.saveOnOff=false
                                    this.onOff = true
                                }else {
                                    this.submitOnOff=true
                                    this.saveOnOff=true
                                    this.onOff = false
                                    this.deleteOnOff = true
                                }
                            }
                            if(res.data.isClosed=='T'){
                                this.onOff=true
                                this.agreedOnOff=false
                                this.refusedOnOff=false
                                this.submitOnOff=false
                                this.saveOnOff=false
                                this.deleteOnOff=false
                                this.writeOnOff=false
                            }
                            //获取头像图片
                            loading.close()
                            for (let j=0;j<this.form.psArray.length;j++){
                                if (this.form.psArray[j].photo_id){
                                    this.getImgUrl(this.form.psArray[j])
                                }else {
                                    this.form.psArray[j].src = tou
                                }
                            }
                        }


                    })

                }catch (e) {
                    loading.close()
                }
            },
            handleBackClick(){
                this.$router.go(-1)
            },
            async getInternalType(){
                let data={
                }

                data.tenant_id = this.$store.getters.getUser.tenant_id
                await http.post('/wapi/InternalList/getInternalType',data).then(res=>{
                    if (res.success == true){
                        // console.log(res.data)
                       this.options_duration = res.data
                    }
                })
            },
            choseProvince(province_name){
                this.form.city_name = ''
                this.addForm.city_name = ''
                this.getCityData(province_name)
            },
            inputBtnSaveClick(){
                if (this.status === 'INFO'){
                    this.$refs["infoForm"].validate(valid=> {
                        if (!valid) {
                            return false
                        } else {
                            this.btnSaveClick()
                        }
                    })
                }else {
                    this.$refs["addForm"].validate(valid=> {
                        if (!valid) {
                            return false
                        } else {
                            this.btnSaveClick()
                        }
                    })
                }

            },
            async btnSaveClick(type){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={}
                    if (this.status === 'INFO'){
                        data=this.form
                    } else {
                        data=this.addForm
                        data.category = 'TRAINING'
                    }
                    if (!(data.activity_date)){
                        this.$message({
                            type:'error',
                            message: '请选择日期'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(data.activity_duration)){
                        this.$message({
                            type:'error',
                            message: '请选择时长'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(data.affair_type)){
                        this.$message({
                            type:'error',
                            message: '请选择类型'
                        })
                        loading.close()
                        return false;
                    }
                    data.tenant_id =this.$store.getters.getUser.tenant_id
                    data.user_id =this.$store.getters.getUser.user_id
                    await http.post('/wapi/InternalList/saveInternalInfo',data).then(res=>{
                        if (res.success === true){
                            if (res.data.message){
                                this.$message({
                                    type:'error',
                                    message: res.data.message
                                })
                                loading.close()
                            } else {

                                if (this.status === 'NEW'){
                                    this.data.activity_id = res.data[0].activity_id
                                    this.status = 'INFO'
                                    this.addForm={
                                        activity_date:'',
                                        activity_duration:'',
                                        comments:'',
                                        start_time:'',
                                        end_time:'',
                                        transportation:'',
                                        province_name:'',
                                        city_name:'',
                                    }
                                }
                                if (type === 'submit'){
                                    let obj={
                                        tenant_id : this.$store.getters.getUser.tenant_id,
                                        status : 'SUBMITTED',
                                        user_id : this.$store.getters.getUser.user_id,
                                        activity_id: this.data.activity_id
                                    }

                                    http.post('/wapi/InternalList/submitInternalPlan',obj).then(res=>{
                                        if (res.success === true){
                                            //this.init()
                                            this.$message({
                                                type:'success',
                                                message:'提交成功'
                                            })
                                            //loading.close()
                                            this.$router.push({
                                                name:'cultivate'
                                            })
                                        }
                                    })
                                }else {
                                    //this.init()
                                    this.$message({
                                        type:'success',
                                        message: '保存成功'
                                    })
                                    this.$router.push({
                                        name:'cultivate'
                                    })
                                    //loading.close()
                                }
                            }

                        } else {
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }
            },
            async btnDeleteClick(){
                this.$confirm('确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        let data=this.form
                        data.tenant_id =this.$store.getters.getUser.tenant_id
                        data.user_id =this.$store.getters.getUser.user_id
                        await http.post('/wapi/InternalList/deleteInternal',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                                this.$router.go(-1)
                            }
                        })
                    }catch (e) {

                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            async savePlanPs(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        type:'INTERNAL',
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        id:this.form.activity_id,
                        user_id : this.$store.getters.getUser.user_id,
                        contents:{
                            comments:this.contents,
                            photos:[]
                        }
                    }
                    await http.post('/wapi/Evection/savePlanPs',data).then(res=>{
                        if (res.success === true){
                            this.init()
                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.modelSavePlanPs= false
                            this.contents = ''
                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }

            },
            openSavePlanModel(){
                this.modelSavePlanPs= true
            },
            async btnSubmitClick(){
                try {
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        status : 'SUBMITTED',
                        user_id : this.$store.getters.getUser.user_id,
                        activity_id: this.form.activity_id
                    }
                    if (this.form.activity_id){
                        await http.post('/wapi/InternalList/submitInternalPlan',data).then(res=>{
                            if (res.success === true){
                                //this.init()
                                this.$message({
                                    type:'success',
                                    message:'提交成功'
                                })
                                this.$router.push({
                                    name:'cultivate'
                                })
                            }

                        })
                    } else {
                        this.btnSaveClick('submit')
                    }

                }catch (e) {

                }
            },
            async btnAgreeClick(){
                try {
                    let data={
                        status:'APPROVED',
                        user_id:this.$store.getters.getUser.user_id,
                        activity_id:this.form.activity_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/InternalList/submitInternalPlan',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'批准成功'
                            })
                            this.$router.push({
                                name:'cultivate'
                            })
                            //this.init()
                        }
                    })

                }catch (e) {

                }
            },
            async btnRefuseClick(){
                try {
                    let data={
                        status:'DENIED',
                        user_id:this.$store.getters.getUser.user_id,
                        activity_id:this.form.activity_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/InternalList/submitInternalPlan',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'批准成功'
                            })
                            //this.init()
                            this.$router.push({
                                name:'cultivate'
                            })
                        }

                    })
                }catch (e) {

                }
            },
            onTypeChange(value,option){
                // console.log(this.form)
            },
            // 获取图片id
            async getImgUrl(obj) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: obj.photo_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data


                    if (array.length > 0) {
                        obj.src = array[0].thu_url
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            handleClose(){

            }
        }
    }
</script>

<style scoped>
    /*#container {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #cultivate_train{
        height: 100%;
    }
    #cultivate_train >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #cultivate_train >>>.el-table_1_column_7{
        color: #3b99f7;
    }
    #cultivate_train >>>.el-table th{
        padding: 7px 0px;
    }
    #cultivate_train >>>.el-table td{
        padding: 7px 0px;
    }
    #cultivate_train >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
        float: right;
    }
    #cultivate_train >>> .el-icon-edit-outline:before{
        margin-right: 5px;
    }
    #cultivate_train >>> .el-icon-time:before{
        margin-right: 5px;
    }
    #cultivate_train >>>.el-icon-edit-outline:before {
        font-size: 16px;
    }
    #cultivate_train >>>.el-icon-edit-outline span{
        position: relative;
        top: -2px;
        font-size: 13px;
    }
</style>
<style>
    #cultivate_train #travelSavePlanPs .el-textarea__inner{
        height: 400px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/train.vue